import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AuthContext } from '../../contexts/AuthContext';

const AllowedRoute = () => {
  const { apiUser, loading: isAuthLoading } = useContext(AuthContext);
  const attemptedRoute = window.location?.pathname;
  const orgPages = apiUser?.organization?.pages || [];
  const pageRoutes: Record<string, string> = {
    'customer-geography': '/customer/geography',
  };
  const matchingKey = Object.keys(pageRoutes).find((key) => pageRoutes[key] === attemptedRoute);
  let proceed: boolean;

  if (!matchingKey) {
    proceed = true;
  } else {
    proceed = orgPages.includes(matchingKey);
  }

  return !isAuthLoading && apiUser ? proceed ? <Outlet /> : <Navigate to="/404" /> : <></>;
};

export default AllowedRoute;
